<template>
    <div class="search-bar">
      <input type="text" v-model="searchTerm" :placeholder="placeholder" @keyup="handleKeyUp">
      <button @click="$emit('search', searchTerm)">Search</button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Search',
    props: {
      placeholder: {
        type: String,
        required: true,
        default: 'Search...', // Provide a default placeholder if none is specified
      },
    },
    data() {
      return {
        searchTerm: '',
      };
    },
    methods: {
      handleKeyUp(event) {
        // Emit the search term using the correct event name
        this.$emit('onsearch', event.target.value);
      },
    },
  };
  </script>
  
  <style scoped>
  .search-bar {
    display: flex; /* Use flexbox for horizontal layout */
    align-items: center; /* Vertically center search input and button */
    flex: 1; /* Expand input to fill available space */
    padding: 0.5rem 1rem;
    /* border: 1px solid #ccc; */
    border-radius: 4px;
    margin-right: 1rem; /* Add margin for spacing */
    float: right; /* Right-align the search bar */
  }
  input::placeholder {
    font-size: 11px;/* Your desired font size here */;
  }
  </style>
  